import { PeekDivider, PeekIconButton, PeekStack, PeekTypography } from "@piiqtechnologies/ui-components";
import React from "react";
import { Trash2 } from "@piiqtechnologies/svg-icons";
const TooltipTitle = ({ title, onDelete }) => {
    return (React.createElement(PeekStack, { direction: "row", spacing: 2, alignItems: "center" },
        React.createElement(PeekTypography, { variant: "body1" }, title),
        React.createElement(PeekStack, { direction: "row", spacing: 2 },
            React.createElement(PeekDivider, { orientation: "vertical", sx: { width: 0.2 }, light: true }),
            React.createElement(PeekIconButton, { onClick: onDelete, "aria-label": "Delete Amenity", color: "default", bordered: false },
                React.createElement(PeekTypography, { fontSize: 18 },
                    React.createElement(Trash2, null))))));
};
export default TooltipTitle;
